
import { Component, Watch, Vue } from "vue-property-decorator"
import WorkReportQuery from "@/graphql/workreport/workreport.graphql"
import GroupQuery from "@/graphql/group/group.graphql"
import DeleteWorkReport from "@/graphql/workreport/deleteworkreport.graphql"
import * as cdn from "@coredination/components"
import { User } from "@coredination/common"
import { CircularLoader } from "@coredination/components"
import moment from "moment"
import { navbar, NavbarOption } from "@/components/NavbarOptions.vue"

@Component({
    apollo: {
        absenceReport: {
            query: WorkReportQuery,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            },
            update(data: any) {
                return data.workReport
            },
            result(result: any) {
                this.absenceReport = result.data.workReport
            },
        },
        me: cdn.graphql.me,
        group: {
            query: GroupQuery,
            skip() {
                return !this.model || this.model.groupName || !this.model.groupUuid
            },
            variables() {
                return { uuid: this.model.groupUuid }
            },
        },
    },
    components: {
        CircularLoader,
        DeleteDialog: () => import("@/components/dialogs/DeleteDialog.vue"),
    },
    props: ["new", "uuid"],
})
export default class ReportAbsenceForm extends Vue {
    uuid?: string
    absenceReport: any = {
        type: "ABSENCE",
        toBeInvoiced: false,
        workDate: new Date().getTime(),
        startTime: null,
        endTime: null,
    }

    me?: User
    group?: any
    showDeleteModal: boolean = false

    get model() {
        return this.absenceReport
    }
    set model(absenceReport: any) {
        this.absenceReport = absenceReport
    }

    get editable(): boolean {
        // TODO: GROUP PERMISSIONS
        return this.me!.permissions!.includes("edit_all_data") || this.me!.permissions!.includes("report_absence")
    }

    hasMultipleActiveGroups() {
        return this.me && this.me.groupMemberships && this.me.groupMemberships!.filter((m: any) => m.active).length > 1
    }

    mounted() {
        this.$apollo.queries.absenceReport.refetch()
        const params: any = {
            ...this.$route.params,
            ...this.$route.query,
        }
        if ("date" in params) {
            Vue.set(this.model, "workDate", moment(params.date).toDate().getTime())
        }
    }

    get loading() {
        return this.$apollo.queries.absenceReport.loading || this.$apollo.queries.me.loading || this.$apollo.queries.group.loading
    }

    @Watch("me")
    watchOptions() {
        if (this.me != null) navbar?.setOptions(this.options)
    }

    get options(): NavbarOption[] {
        if (!this.me || !this.me.permissions) return []
        var options = []
        if (this.editable)
            options.push({
                icon: "edit",
                to: `/workreport/absence/${this.uuid}/edit`,
            })
            options.push({
                title: this.$t("absenceReportOptions_deleteAbsenceReport"),
                action: this.clickDelete,
            })
        return options
    }

    clickDelete() {
        this.showDeleteModal = !this.showDeleteModal
        // this.$router.back()
    }

    confirmDelete() {
        var self: any = this
        var uuid: string = this.model.uuid
        return this.$apollo
            .mutate({
                mutation: DeleteWorkReport,
                variables: { uuid },
                update(proxy, response) {
                    self.invalidateCache(proxy, response, true)
                },
            })
            .then(async (response) => {
                console.log("Workreport deleted", response)
                self.$router.back()
            })
    }

}
